<a [href]="website" class="link text-size-14 fw-500 flex-box-center line-height-1-2">
  <lib-icon color="var(--color-primary)">left-big</lib-icon>
  <span>{{websiteURLValue}}</span>
</a>
